import {
  CustomButton,
  CustomImage,
  CustomModal,
  errorDialog,
  Text,
  useText,
} from '@src/components';
import modalClose from '@src/assets/icons/icon-close.svg';
import React, { useCallback, useState } from 'react';
import { Radio } from 'antd';
import '@src/styles/myOrders/downloadModal.scss';
import reportsServices from '@src/services/reports.services';
import orderServices from '@src/services/order.services';
import { useSelector } from 'react-redux';
import download from 'js-file-download';
import PropTypes from 'prop-types';
import { VouIdCode } from '@src/store/enums';

const DownloadModal = ({ modalVisible, handleModalVisible, isCompliments = false, isMarket = false }) => {
  const [selectedValue, setSelectedValue] = useState(undefined);
  const { selectedCustomer } = useSelector((state) => state?.customer);
  const { selectedOrder } = useSelector((state) => state?.order);
  let vouId;
  if (isMarket) {
    vouId = VouIdCode.Market;
  } else if (isCompliments) {
    vouId = VouIdCode.Compliments;
  } else {
    vouId = VouIdCode.Restaurant;
  }

  const handleClose = useCallback(
    (e) => {
      e.preventDefault();
      setSelectedValue(null);
      handleModalVisible(false);
    },
    [handleModalVisible],
  );

  const onChange = useCallback((e) => {
    setSelectedValue(e.target.value);
  }, []);

  const handeDownload = async () => {
    const customerId = selectedCustomer?.customerId;

    if (selectedValue === 'pdf') {
      await pdfDownload(customerId);
    }
    if (selectedValue === 'excel') {
      await excelDownload(customerId);
    }
    if (selectedValue === 'csv') {
      await csvDownload(customerId);
    }
  };

  const pdfDownload = useCallback(
    async (customerId) => {
      let data = {
        customerId,
        orderId: selectedOrder?.id,
        vouId: vouId,
      };

      try {
        const blob = await reportsServices.getOrderSummaryPdfReport(data);
        await download(
          blob,
          `${selectedOrder?.id} - ${selectedOrder?.orderDate.split('T')[0]}.pdf`,
        );
        handleModalVisible(!blob);
      } catch (error) {
        errorDialog({
          title: <Text t="error" />,
          message: error?.statusText,
        });
      }
    },
    [selectedOrder],
  );

  const excelDownload = useCallback(
    async (customerId) => {
      let data = {
        customerId,
        downloadType: 2,
        orderId: selectedOrder?.id,
        vouId: vouId,
      };

      try {
        const blob = await orderServices.downloadOrderFile(data);
        await download(
          blob,
          `${selectedOrder?.id} - ${selectedOrder?.orderDate.split('T')[0]}.xlsx`,
        );
        handleModalVisible(!blob);
      } catch (error) {
        errorDialog({
          title: <Text t="error" />,
          message: error?.statusText,
        });
      }
    },
    [handleModalVisible, selectedOrder?.id],
  );

  const csvDownload = useCallback(
    async (customerId) => {
      let data = {
        customerId,
        downloadType: 3,
        orderId: selectedOrder?.id,
        vouId: vouId,
      };

      try {
        const blob = await orderServices.downloadOrderFile(data);
        await download(
          blob,
          `${selectedOrder?.id} - ${selectedOrder?.orderDate.split('T')[0]}.csv`,
        );
        handleModalVisible(!blob);
      } catch (error) {
        errorDialog({
          title: <Text t="error" />,
          message: error?.statusText,
        });
      }
    },
    [selectedOrder],
  );

  return (
    <CustomModal
      className="download-modal"
      maskClosable={false}
      footer={false}
      title={useText('download')}
      visible={modalVisible}
      onCancel={handleClose}
      closeIcon={<CustomImage src={modalClose} />}
    >
      <div className="download-container">
        <Radio.Group
          id="ticketRestaurant-myOrders-downloadModal-custom-radioGroup-input-content"
          onChange={onChange}
          value={selectedValue}
          className="custom-radio-input-content"
        >
          <Radio
            id="ticketRestaurant-myOrders-downloadModal-custom-radio-input-content-pdf"
            data-testid="pdf"
            value="pdf"
            className="custom-radio-input"
          >
            PDF
          </Radio>
          <Radio
            id="ticketRestaurant-myOrders-downloadModal-custom-radio-input-content-excel"
            data-testid="excel"
            value="excel"
            className="custom-radio-input"
          >
            Excel
          </Radio>
          <Radio
            id="ticketRestaurant-myOrders-downloadModal-custom-radio-input-content-csv"
            data-testid="csv"
            value="csv"
            className="custom-radio-input"
          >
            CSV
          </Radio>
        </Radio.Group>

        <div className="footer-btn">
          <CustomButton
            id="ticketRestaurant-myOrders-downloadModal-download-btn"
            data-testid="download"
            className="download-btn"
            onClick={handeDownload}
          >
            <Text t="download" />
          </CustomButton>
          <CustomButton
            id="ticketRestaurant-myOrders-downloadModal-cancel-btn"
            data-testid="cancel"
            className="cancel-btn"
            onClick={handleClose}
          >
            <Text t="giveUp" />
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
};

DownloadModal.propTypes = {
  modalVisible: PropTypes.any,
  isCompliments: PropTypes.bool,
  isMarket: PropTypes.bool,
  handleModalVisible: PropTypes.func,
};
export default DownloadModal;
